import { Injector } from "@angular/core";
import { ListView } from "../../../Data/ListView";
import { Art57Node } from "../Art57Node";
import { Art57NodeList } from "../Art57NodeList";
import { TreeNodeSubstanceAliasTranslations } from "../Entity/TreeNodeSubstanceAliasTranslations";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeSubstanceAliasTranslationsList extends Art57NodeList {
    constructor(injector: Injector, parent: Art57Node) {
      super(injector, new ListView(), 'Alias Translations ({param})');
      this.parent = parent;
      this.labelNodeName = 'Alias Translations';      
    }
  
    override refreshLabel(): void {
      this.label = this.labelTemplate.replace(
        '{param}',
        this.getLabelParamFromChildren()
      );
    }
  
    override createChildTemplate(): Art57Node[] | null {
      let node = new TreeNodeSubstanceAliasTranslations(this.ioc!, this);
      this.children?.push(node);
  
      this.refreshLabel();
  
      return [node];
    }
  
    override getMessage(): any {
      let aliastranslations: Art57Node[] = [];
      this.children?.forEach((node) => {
        let aliastranslation = node as Art57Node;
        aliastranslations.push(aliastranslation.getMessage());
      });
      if (aliastranslations.length > 0) {
        return { aliastranslations: { aliastranslation: aliastranslations } };
      } else {
        return undefined;
      }
    }
  
    override getHeaders(): string[] {
      return ['Language', 'Translation'];
    }
  
    override cloneNode(newParent: Art57Node): Art57Node|undefined {
      let clonedNode: TreeNodeSubstanceAliasTranslationsList =
        new TreeNodeSubstanceAliasTranslationsList(this.ioc!, newParent);
  
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      this.children?.forEach((child) => {
        let childToClone = child as Art57Node;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      return clonedNode;
    }
  }